//#region Imports
import { createAction, props } from '@ngrx/store';
import { NextPayment, PaymentList } from './../../interfaces';

//#region Action ids

enum PaymentsActionIds {
    loadPayments = '[Payments] Load payment list',
    resetPayments = '[Payments] Reset payment list',
    setPayments = '[Payments] Set payment list',
}

//#region Actions

export const LoadPaymentsAction = createAction(
    PaymentsActionIds.loadPayments
);

export const ResetPaymentsAction = createAction(
    PaymentsActionIds.resetPayments
);

export const SetPaymentsAction = createAction(
    PaymentsActionIds.setPayments,
    props<{ list: PaymentList, next: NextPayment }>()
);